import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';
import { useDraftCqrsFind } from '@dreryk/react-draft';

import { getMedicalCertificateDraftToken, medicalCertificateDraftSchema } from '../medicalCertificate.draft';
import { medicalCertificateTranslationKeys } from '../translations';

import { MedicalCertificateFormBean } from './MedicalCertificateForm.types';

type MedicalCertificateFormRenderer = (renderProps: {
   medicalCertificateDraft: MedicalCertificateFormBean | null;
}) => JSX.Element;

type MedicalCertificateFormLoaderProps = {
   readonly visitId: number;
   readonly children: MedicalCertificateFormRenderer;
};

export const MedicalCertificateFormLoader = (props: MedicalCertificateFormLoaderProps): JSX.Element => {
   const {
      data: medicalCertificateDraft,
      loading: medicalCertificateDraftLoading,
      error: medicalCertificateDraftError,
   } = useDraftCqrsFind(
      {
         token: getMedicalCertificateDraftToken(props.visitId),
      },
      medicalCertificateDraftSchema
   );

   if (medicalCertificateDraftLoading) {
      return <LoaderSpinner />;
   }

   if (medicalCertificateDraftError) {
      return (
         <Message
            testId={'failedToFetch'}
            label={medicalCertificateTranslationKeys.form.loader.failedToFetch}
            type={MessageType.NEGATIVE}
            displayIndicator
         />
      );
   }

   return props.children({
      medicalCertificateDraft: medicalCertificateDraft?.contents ?? null,
   });
};
